import React from 'react';
import { motion } from 'framer-motion';
import { CalendarIcon, MapPinIcon, BookOpenIcon, CompassIcon } from 'lucide-react';
export function Organization() {
  return <section id="termin" className="w-full bg-white py-24 px-6 scroll-mt-20" data-id="element-170" data-mp="31d77bzaclvk7">
      <div className="max-w-5xl mx-auto" data-id="element-171" data-mp="31b476mfhem1r">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-172" data-mp="35eahc55psxdi">
          <h2 className="text-[48px] font-[200] text-navy-deep mb-4" data-id="element-173" data-mp="3k5sxc2ykqrwv">
            Termín a organizace 2027
          </h2>
          <div className="flex items-center justify-center gap-6 text-navy-deep/70 text-lg" data-id="element-174" data-mp="28ojg7n2x4byq">
            <span className="flex items-center gap-2" data-id="element-175" data-mp="28qw2udjmfai4">
              15. – 22. května 2027
            </span>
            <span className="flex items-center gap-2" data-id="element-176" data-mp="3qw4l3fxsmo7m">
              <MapPinIcon className="w-5 h-5 text-blue-medium" data-id="element-177" data-mp="3qwwf4mbqsdvs" />
              Marina Biograd na Moru
            </span>
          </div>
        </motion.div>

        {/* Marina sunset hero photo */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 1
      }} className="mb-16 rounded-2xl overflow-hidden shadow-lg" data-id="element-178" data-mp="4qr5c593axm0">
          <img src="https://cdn.magicpatterns.com/uploads/9iUbMW7EXRNfa4RJsoELHD/16-9-fullframe-export_(0;00;41;00)_molo.jpg" alt="Marina Biograd na Moru při západu slunce" className="w-full h-72 md:h-96 object-cover" data-id="element-179" data-mp="nemdn9lxnj7q" />
        </motion.div>

        <div className="relative border-l-2 border-mist ml-4 md:ml-8 space-y-12" data-id="element-180" data-mp="sfacuikbf6d1">
          {/* Sobota */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="relative pl-8 md:pl-12" data-id="element-181" data-mp="ziqgkhlkr5kr">
            <div className="absolute -left-[11px] top-1 w-5 h-5 rounded-full bg-blue-medium border-4 border-white" data-id="element-182" data-mp="1i983g5jq76y7" />
            <h3 className="text-2xl font-semibold text-navy-deep mb-2" data-id="element-183" data-mp="1n6hyc0pvwatf">
              Sobota: Přebírání lodí
            </h3>
            <p className="text-navy-deep/70 mb-4" data-id="element-184" data-mp="1s7e28ea8jwyu">
              Lodě si přebírá každý kapitán sám. Platí se vratná kauce (2 700 €)
              a pobytová taxa. První noc se kotví v domácí maríně. Večer
              proběhne úvodní shromáždění s informacemi o zahájení plavby.
            </p>
            <div className="bg-off-white p-4 rounded-lg inline-flex items-start gap-3" data-id="element-185" data-mp="2ry8o78soju2">
              <BookOpenIcon className="w-5 h-5 text-blue-medium shrink-0 mt-0.5" data-id="element-186" data-mp="2g3iulc1vm4k5" />
              <span className="text-sm text-navy-deep/80" data-id="element-187" data-mp="2ba6g3uqwve54">
                <strong data-id="element-188" data-mp="279npg40r8e4i">Dobrovolná přednáška:</strong> Kotvení a přístavní
                manévry (pro žadatele o potvrzení praxe povinná).
              </span>
            </div>
          </motion.div>

          {/* Neděle */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative pl-8 md:pl-12" data-id="element-189" data-mp="2z13jgj4n534r">
            <div className="absolute -left-[11px] top-1 w-5 h-5 rounded-full bg-blue-medium border-4 border-white" data-id="element-190" data-mp="1elrtx2mx8s9b" />
            <h3 className="text-2xl font-semibold text-navy-deep mb-2" data-id="element-191" data-mp="19kaxbjbgzryj">
              Neděle: Trénink a přesun
            </h3>
            <p className="text-navy-deep/70 mb-4" data-id="element-192" data-mp="2xgqw23k12qh3">
              Dopoledne probíhá trénink s možností vypůjčit si zkušenějšího
              kapitána pro nacvičení základních manévrů a genakeru. Po obědě
              přednáška "Startovní procedura - pravidla". Odpoledne přesun
              jižněji s praktickým nácvikem startů.
            </p>
          </motion.div>

          {/* Pondělí - Čtvrtek */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="relative pl-8 md:pl-12" data-id="element-193" data-mp="3l85xlu3zd3ra">
            <div className="absolute -left-[11px] top-1 w-5 h-5 rounded-full bg-blue-medium border-4 border-white" data-id="element-194" data-mp="20su9mi1wt0xy" />
            <h3 className="text-2xl font-semibold text-navy-deep mb-2" data-id="element-195" data-mp="1t7qp227xooi0">
              Pondělí – Čtvrtek: Plavba
            </h3>
            <p className="text-navy-deep/70" data-id="element-196" data-mp="1o9ff7rhn2dzs">
              Od pondělního rána se pluje dle dispozic rozhodčích mimo domácí
              marínu. Harmonogram bude podřízen počasí se snahou odjet co
              nejvíce rozjížděk.
            </p>
          </motion.div>

          {/* Pátek / Sobota */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.6
        }} className="relative pl-8 md:pl-12" data-id="element-197" data-mp="19l2fqkjced0j">
            <div className="absolute -left-[11px] top-1 w-5 h-5 rounded-full bg-mist border-4 border-white" data-id="element-198" data-mp="qryjqsinjo2r" />
            <h3 className="text-2xl font-semibold text-navy-deep/60 mb-2" data-id="element-199" data-mp="2lxhefv1lwz1c">
              Pátek / Sobota: Návrat
            </h3>
            <p className="text-navy-deep/60" data-id="element-200" data-mp="2qvsoa5rwj9jk">
              Návrat do domovské maríny a vrácení lodí nejpozději v sobotu ráno.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}